<template lang="html">

  <section class="banner-beneficios column-center animation" id="beneficios" :style="`background:url('/static/img/productos/${data}/background-intro-beneficios.jpg') center/cover no-repeat`">
    <div class="container -xxs textos">
      <router-link class="enlace-cover" :to="`${$t('enlaces.productos')}/${$route.params.id}${$t('enlaces.beneficios')}`"></router-link>
      <h2 class="title -xs">{{$t(`productos.${data}.banner_beneficios.titulo`)}}</h2>
      <router-link class="btn" :to="`${$t('enlaces.productos')}/${$route.params.id}${$t('enlaces.beneficios')}`">
        <span>{{$t(`productos.${data}.banner_beneficios.boton`)}}</span>
      </router-link>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'banner-beneficios',
    props : ['data']
}
</script>

<style scoped lang="scss">
.banner-beneficios {
  padding: 100px 0;
  height: 390px;
  position: relative;
  overflow: hidden;

  .container{
    max-width: 768px;
  }

  .title{
    margin-bottom: 30px;
    text-align: center;
    line-height: 40px;
    transform: translateY(500px);
    opacity: 0;
    transition: 1s;
  }

  .btn{
    position: relative;
    z-index: 6;
    transform: translateY(500px);
    opacity: 0;
    transition: 1s;
    transition-delay: .5s;
  }

  &.launched{
    .title, .btn{
      opacity: 1;
      transform: translateY(0);
    }
  }
}

@media screen and (max-width: 700px){
  .banner-beneficios .title{
    line-height: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/productos/banner-beneficios.vue